import { Dialog } from 'apps/studio/components/dialogs'
import { CloseIcon } from '@gocanvas/gcds/icons'

export const CancelConfirmDialog = ({
  onCancel,
  onConfirm,
  title = 'Are you sure?',
  description = '',
  cancelText = 'No, go back',
  confirmText = 'Yes, exit',
}) => {
  return (
    <Dialog className="cancel-confirm--dialog">
      <div className="dialog--header">
        <h2 className="dialog--title">{title}</h2>
      </div>
      <div className="dialog--content">{description}</div>
      <div className="dialog--footer">
        <button
          className={`gcds--button button--secondary`}
          type="button"
          onClick={onCancel}
        >
          <CloseIcon className="icon--leading" />
          <span className="button--label">{cancelText}</span>
        </button>
        <button
          className={`gcds--button button--primary`}
          type="button"
          onClick={onConfirm}
        >
          <span className="button--label">{confirmText}</span>
        </button>
      </div>
    </Dialog>
  )
}
